export const GET_IMAGE= 'GET_IMAGE'
export const GET_IMAGE_SUCCESS= 'GET_IMAGE_SUCCESS'
export const GET_IMAGE_ERROR= 'GET_IMAGE_ERROR'

export const GetImage = (data) => ({
    type: GET_IMAGE,
    payload: data
})